module.exports = __webpack_public_path__ + "img/setting.6291b25b.png";